import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesAdvancedContractSigningComponent} from "./sales-advanced-contract-signing.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {SalesErrorMessageModule} from "../error-message/sales-error-message.module";



@NgModule({
  declarations: [
    SalesAdvancedContractSigningComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule,
    SalesErrorMessageModule
  ],
  exports: [
    SalesAdvancedContractSigningComponent
  ]
})
export class SalesAdvancedContractSigningModule { }
